import { Observable } from '../Observable';
export function operate(init) {
    return function (source) { return new Observable(function (subscriber) { return init(source, subscriber); }); };
}
//# sourceMappingURL=lift.js.map